<script>
  import { onMount } from 'svelte';
  let eggRevealed = false;
  let currentView = 'list';
  let events = [];
  let loading = true;
  let error = null;


  const CALENDAR_ID = '810b129c57409672a9fb084a3575d63ed8e6abf8ca9802d77bb445ce4cb9792c@group.calendar.google.com';
  const API_KEY = 'AIzaSyA9ARrhM-sV-zBFBfy19fRhziZ4uC578rM';


  async function fetchEvents() {
    try {
      loading = true;
      const now = new Date();
      // Extend the date range to include future years
      const futureDate = new Date(now.getFullYear() + 1, 11, 31); // December 31st of next year
     
      console.log('Fetching events from:', now.toISOString(), 'to:', futureDate.toISOString());
     
      const response = await fetch(
        `https://www.googleapis.com/calendar/v3/calendars/${encodeURIComponent(CALENDAR_ID)}/events?` +
        `key=${API_KEY}&` +
        `timeMin=${now.toISOString()}&` +
        `timeMax=${futureDate.toISOString()}&` +
        `singleEvents=true&` +
        `orderBy=startTime`
      );


      if (!response.ok) {
        throw new Error(`Failed to fetch events: ${response.status} ${response.statusText}`);
      }


      const data = await response.json();
      console.log('API Response:', data);


      if (!data.items || data.items.length === 0) {
        console.log('No events found in the response');
        events = [];
        return;
      }


      events = data.items
        .filter(event => {
          // Filter out any events that might be in the past
          const eventDate = new Date(event.start.dateTime || event.start.date);
          return eventDate >= now;
        })
        .map(event => {
          console.log('Processing event:', event);
          return {
            title: event.summary || 'Untitled Event',
            description: event.description || 'No description available',
            startTime: new Date(event.start.dateTime || event.start.date),
            endTime: new Date(event.end.dateTime || event.end.date),
            location: event.location || 'Iribe Center',
            link: event.htmlLink
          };
        })
        .sort((a, b) => a.startTime - b.startTime);


      console.log('Processed events:', events);
    } catch (err) {
      error = err.message;
      console.error('Error fetching events:', err);
    } finally {
      loading = false;
    }
  }


  function formatTime(date) {
    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  }


  function formatDay(date) {
    return date.toLocaleDateString('en-US', { weekday: 'short' }).toUpperCase();
  }


  function formatDate(date) {
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  }


  onMount(() => {
    fetchEvents();
  });


  function handleEasterEggReveal() {
    eggRevealed = true;
  }


  function setView(view) {
    currentView = view;
    // Update active button state
    document.querySelectorAll('.view-button').forEach(btn => {
      btn.classList.toggle('active', btn.textContent.toLowerCase().includes(view));
    });
  }
</script>


<div class="about-container">
  <h1 style="color:white">About</h1>
  <h2 style="color:white">UMD ACM Chapter</h2>
  <p style="color:white">
    We're a student-run CS club building a community of coders, creators, and
    problem-solvers.
  </p>


  <div class="join-section">
    <h2>Ready to Join?</h2>
    <p>Join our community today and start your tech journey with us!</p>
    <div class="join-buttons">
      <button
        on:click={() => window.location.href = "https://discord.com/invite/4HkYzUpN67"}
        class="join-button discord">
        <img src="/assets/icons/discord-white-icon.svg" alt="Discord" class="join-icon" />
        Join Our Discord
      </button>
      <button
        on:click={() => window.location.href = "https://terplink.umd.edu/organization/acm"}
        class="join-button terplink">
        <img src="/assets/icons/terplink-logo.svg" alt="Terplink" class="join-icon" />
        Join on Terplink
      </button>
    </div>
  </div>


  <p>
    <a
      href="https://www.acm.org/about-acm/about-the-acm-organization"
      target="_blank">What is ACM?</a
    >
  </p>


  <div class="contact-info">
    <h2>Connect with Us</h2>
    <p>Find us online or send us a message:</p>


    <div class="social-links">
      <a href="https://acm-umd.vercel.app/" target="_blank">Website</a>
      <a href="https://discord.gg/AVV5zeVt4S" target="_blank">Discord</a>
      <a href="https://www.instagram.com/acm.umd/" target="_blank">Instagram</a>
      <a href="https://www.reddit.com/user/ACM_UMD/" target="_blank">Reddit</a>
      <a href="https://linktr.ee/ACM_UMD" target="_blank">Linktree</a>
      <a href="mailto:acm@cs.umd.edu">Email Us</a>
    </div>


    <p style="margin-top: 15px">
      <strong>Address:</strong><br />
      Brendan Iribe Center<br />
      College Park, MD 20742
    </p>
  </div>


  <div class="mission-statement">
    <h2>Our Mission</h2>
    <p>
      Empower students through weekly workshops, hands-on tech projects, and
      guest talks from industry pros.
    </p>
  </div>


  <div class="membership">
    <h2>Join Us!</h2>
    <p>
      Open to all majors. No dues. Just show up and code.
        {#if !eggRevealed}
          <button class="easter-egg-button" on:click={handleEasterEggReveal}>
            Shh...
          </button>
        {:else}
          <span class="easter-egg-reveal">
            🥚 YUM Easter egg! More are hidden — JZ!
          </span>
        {/if}
    </p>


    <h2>Get Involved</h2>
    <p>
      Join our weekly meetings every Tuesday @ 6 PM in the Iribe Center. Check
      Discord for room updates.
    </p>


    <h2>General Meetings</h2>
    <p>Low time commitment, high value. Learn, connect, and build with us!</p>


    <h2>Upcoming Events</h2>
    <div class="calendar-section">
        <div class="calendar-container">
            <div class="calendar-view-toggle">
                <button class="view-button active" on:click={() => setView('list')}>List View</button>
                <button class="view-button" on:click={() => setView('calendar')}>Calendar View</button>
            </div>
           
            {#if currentView === 'list'}
                <div class="events-list">
                    {#if loading}
                        <div class="loading-state">
                            <div class="spinner"></div>
                            <p>Loading events...</p>
                        </div>
                    {:else if error}
                        <div class="error-state">
                            <p>Error loading events: {error}</p>
                            <button on:click={fetchEvents} class="retry-button">Retry</button>
                        </div>
                    {:else if events.length === 0}
                        <div class="no-events">
                            <p>No upcoming events found</p>
                        </div>
                    {:else}
                        {#each events as event}
                            <div class="calendar-event">
                                <div class="event-date">
                                    <span class="event-day">{formatDay(event.startTime)}</span>
                                    <span class="event-date-full">{formatDate(event.startTime)}</span>
                                    <span class="event-time">{formatTime(event.startTime)}</span>
                                </div>
                                <div class="event-details">
                                    <h3>{event.title}</h3>
                                    <p>{event.description}</p>
                                    <span class="event-location">{event.location}</span>
                                    {#if event.link}
                                        <a href={event.link} target="_blank" class="event-link">View in Calendar</a>
                                    {/if}
                                </div>
                            </div>
                        {/each}
                    {/if}
                </div>
            {:else}
                <div class="calendar-iframe-container">
                    <iframe
                        src="https://calendar.google.com/calendar/embed?height=600&wkst=1&ctz=America%2FNew_York&bgcolor=%23ff6969&showPrint=0&showTabs=0&showTz=0&showCalendars=0&title=ACM%20Events&src=ODEwYjEyOWM1NzQwOTY3MmE5ZmIwODRhMzU3NWQ2M2VkOGU2YWJmOGNhOTgwMmQ3N2JiNDQ1Y2U0Y2I5NzkyY0Bncm91cC5jYWxlbmRhci5nb29nbGUuY29t&color=%23F09300"
                        class="calendar-iframe"
                        frameborder="0"
                        scrolling="no">
                    </iframe>
                </div>
            {/if}
        </div>
    </div>
  </div>
</div>


<style>
  @keyframes slideInBottom {
    0% {
      transform: translateY(100%);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }


  @keyframes slideInRight {
    0% {
      transform: translateX(100%);
      font-size: 10px;
      opacity: 0;
    }
    50% {
      transform: translateX(0);
      font-size: 10px;
      opacity: 1;
    }
    100% {
      transform: translateX(0);
      font-size: 40px;
      opacity: 1;
    }
  }


  @keyframes slideInRight2 {
    0% {
      transform: translateX(100%);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }



  .about-container {
    animation: slideInBottom 0.5s ease forwards;
    padding: 20px;
    max-width: 800px;
    margin: auto;
    background: linear-gradient(to bottom, #652da9, #e55454);
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }


  h1,
  h2 {
    color: #f1373a;
    margin-bottom: 10px;
  }


  a {
    color: #ffd520;
    text-decoration: none;
  }


  a:hover {
    text-decoration: underline;
  }


  .contact-info {
    animation: slideInBottom 1.5s ease forwards;
  }


  .contact-info,
  .mission-statement,
  .membership {
    background-color: #4b4a4a;
    color: #fff;
    padding: 20px;
    border-radius: 10px;
    margin-bottom: 20px;
  }



  p {
    line-height: 1.6;
    margin-bottom: 10px;
  }


  .social-links {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
    margin-top: 10px;
  }


  .social-links a {
    background-color: #ffd520;
    color: #000;
    padding: 10px 15px;
    border-radius: 8px;
    font-weight: bold;
    transition:
      background-color 0.3s ease,
      transform 0.2s ease;
    text-align: center;
    min-width: 120px;
  }


  .social-links a:hover {
    background-color: #f5c400;
    transform: translateY(-2px);
  }


  .easter-egg-button {
    padding: 0.3rem 0.6rem;
    border: none;
    border-radius: 6px;
    background-color: transparent;
    color: rgba(255, 255, 255, 0.3);
    font-size: 0.8rem;
    font-weight: normal;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: none;
    opacity: 0.3;
  }


  .easter-egg-button:hover {
    color: #ffd520;
    opacity: 0.7;
    transform: scale(1.05);
    background-color: rgba(255, 255, 255, 0.05);
  }


  .easter-egg-reveal {
    font-size: 0.9rem;
    color: #fff;
    background: rgba(255, 255, 255, 0.15);
    padding: 0.5rem;
    border-radius: 6px;
    display: inline-block;
    animation: popIn 0.4s ease;
  }


  @keyframes popIn {
    from {
      transform: scale(0.8);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }




  .join-section {
    background: linear-gradient(135deg, #ff4433, #ffd520);
    padding: 2rem;
    border-radius: 10px;
    margin: 2rem 0;
    text-align: center;
    animation: slideInBottom 1.5s ease forwards;
  }


  .join-section h2 {
    color: white;
    font-size: 2rem;
    margin-bottom: 1rem;
  }


  .join-section p {
    color: white;
    font-size: 1.2rem;
    margin-bottom: 1.5rem;
  }


  .join-buttons {
    display: flex;
    justify-content: center;
    gap: 1rem;
    flex-wrap: wrap;
  }


  .join-button {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 1rem 2rem;
    border-radius: 50px;
    font-weight: bold;
    text-decoration: none;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    min-width: 200px;
    justify-content: center;
  }


  .join-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  }


  .join-button.discord {
    background: #5865F2;
    color: white;
  }


  .join-button.terplink {
    background: #E13784;
    color: white;
  }


  .join-icon {
    width: 24px;
    height: 24px;
  }


  @media (max-width: 600px) {
    .join-buttons {
      flex-direction: column;
      align-items: center;
    }


    .join-button {
      width: 100%;
      max-width: 300px;
    }
  }


  .calendar-section {
    background-color: #4b4a4a;
    color: #fff;
    padding: 20px;
    border-radius: 10px;
    margin-bottom: 20px;
    animation: slideInBottom 1.5s ease forwards;
  }


  .calendar-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 1rem;
  }


  .calendar-view-toggle {
    display: flex;
    justify-content: center;
    gap: 1rem;
    margin-bottom: 1.5rem;
  }


  .view-button {
    padding: 0.5rem 1.5rem;
    border: none;
    border-radius: 25px;
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
    cursor: pointer;
    transition: all 0.3s ease;
    font-weight: bold;
  }


  .view-button:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: translateY(-2px);
  }


  .view-button.active {
    background: #ffd520;
    color: #000;
  }


  .calendar-iframe-container {
    width: 100%;
    height: 600px;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  }


  .calendar-iframe {
    width: 100%;
    height: 100%;
    border: none;
    background: rgba(255, 255, 255, 0.1);
  }


  .events-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }


  .calendar-event {
    display: flex;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 10px;
    padding: 1rem;
    transition: all 0.3s ease;
    border: 1px solid rgba(255, 255, 255, 0.1);
  }


  .calendar-event:hover {
    transform: translateX(5px);
    background: rgba(255, 255, 255, 0.15);
    border-color: rgba(255, 213, 32, 0.3);
  }


  .event-date {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 100px;
    padding: 0.5rem;
    background: rgba(255, 213, 32, 0.2);
    border-radius: 8px;
    margin-right: 1rem;
  }


  .event-day {
    font-weight: bold;
    color: #ffd520;
    font-size: 1.2rem;
    margin-bottom: 0.25rem;
  }


  .event-date-full {
    font-size: 0.8rem;
    color: #fff;
    margin-bottom: 0.25rem;
  }


  .event-time {
    font-size: 0.9rem;
    color: #fff;
  }


  .event-details {
    flex: 1;
  }


  .event-details h3 {
    color: #ffd520;
    margin: 0 0 0.5rem 0;
    font-size: 1.2rem;
  }


  .event-details p {
    margin: 0 0 0.5rem 0;
    color: #e0e0e0;
  }


  .event-location {
    font-size: 0.9rem;
    color: #888;
  }


  @media (max-width: 768px) {
    .calendar-event {
      flex-direction: column;
      gap: 1rem;
      padding: 0.75rem;
    }

    .event-date {
      flex-direction: row;
      justify-content: space-between;
      min-width: auto;
      width: calc(100% - 1.5rem);
      margin-right: 0;
      padding: 0.5rem 0.75rem;
      box-sizing: border-box;
    }

    .event-day, .event-date-full, .event-time {
      margin: 0;
      font-size: 0.9rem;
    }

    .event-details {
      width: 100%;
      padding: 0 0.25rem;
    }
  }


  .loading-state, .error-state, .no-events {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    text-align: center;
  }


  .spinner {
    width: 40px;
    height: 40px;
    border: 4px solid rgba(255, 255, 255, 0.1);
    border-left-color: #ffd520;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 1rem;
  }


  @keyframes spin {
    to { transform: rotate(360deg); }
  }


  .retry-button {
    margin-top: 1rem;
    padding: 0.5rem 1rem;
    background: #ffd520;
    color: #000;
    border: none;
    border-radius: 25px;
    cursor: pointer;
    transition: all 0.3s ease;
  }


  .retry-button:hover {
    background: #f5c400;
    transform: translateY(-2px);
  }


  .event-link {
    display: inline-block;
    margin-top: 0.5rem;
    color: #ffd520;
    text-decoration: none;
    font-size: 0.9rem;
    transition: all 0.3s ease;
  }


  .event-link:hover {
    text-decoration: underline;
    color: #f5c400;
  }
</style>
